export class DataWithGroupKey<T>
{
    constructor (public key: string, public value: T = null)
    {
    }
}
